import { z } from 'zod'

/** 사주 분석에 필요한 기본 생년월일 정보 스키마 (온보딩 폼, 저장 정보 드로어 공용) */
export const birthInfoSchema = z.object({
  gender: z.union([z.literal('MALE'), z.literal('FEMALE'), z.literal('')]).refine((v) => v !== ''),
  name: z.string().min(1),
  birthYear: z.string().length(4),
  birthMonth: z.string().min(1).max(2),
  birthDay: z.string().min(1).max(2),
  birthTime: z.string(),
  isLunar: z.boolean(),
})

export type BirthInfoValues = z.input<typeof birthInfoSchema>
